// Identifiers for authentication providers
export const AUTHENTICATION_PROVIDER_MY_KONICA_MINOLTA = "831cd132-e5f8-4077-9a7c-0991396ecba6";
export const AUTHENTICATION_PROVIDER_MY_KMBS = "bd434547-bbfe-4332-9eeb-9dcc23f4aca4";